<template>
  <b-row style="margin-top: 0px !important" id="medic-assistance" class="section-invert reverse-sm">
    <b-col md="12" lg="6" class="content my-auto">
      <h3>{{ $t("medical-assistance.title") }}</h3>
      <p class="text-info">
        {{ $t("medical-assistance.subtitle") }}
        <br /><br />
        {{ $t("medical-assistance.content") }}
        <br /><br />
        {{ $t("medical-assistance.available-consultations") }}
      </p>
      <div class="subtitle">
        <div class="subtitle-list subtitle-list mt-sm-5">
          <div>
            <p>
              <v-icon large v-text="'mdi-video-plus-outline'"></v-icon
              >{{ $t("medical-assistance.video") }}
            </p>
          </div>
          <div>
            <p>
              <v-icon large v-text="'mdi-cellphone-information'"></v-icon
              >{{ $t("medical-assistance.phone-attention") }}
            </p>
          </div>
          <div>
            <p>
              <v-icon
                large
                v-text="'mdi-file-document-multiple-outline'"
              ></v-icon
              >{{ $t("medical-assistance.written-consultation") }}
            </p>
          </div>
          <div>
            <p>
              <v-icon large v-text="'mdi-comment-processing-outline'"></v-icon
              >{{ $t("medical-assistance.chat") }}
            </p>
          </div>
          <!-- <div>
            <p>
              <img src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png" height="85px"/>
              {{ $t("medical-assistance.electronic-prescription") }}
            </p>
          </div> -->
        </div>
      </div>
      <router-link to="/opensaludprime/asistenciamedica"> 
       <base-button style="color:white" class="btn-more-info-white" white outline href=""><span style="color:white">{{ $t('more-info-btn') }}</span></base-button>
      </router-link> 
      </b-col>
    <b-col md="12" lg="6">
      <div class="col-bg ml-lg-auto"></div>
    </b-col>
  </b-row>
</template>

<script>
  export default {
  }
</script>

<style lang="scss">
  @import "../../../static-appopensalud/css/public/layout.scss";
  #medic-assistance .col-bg {
    background-image: url(/static-appopensalud/img/bgs/medical-assistance.jpeg),
      linear-gradient(273deg, #ffffff96, transparent);
    background-position: center;
    background-blend-mode: overlay;

  }
  @media (max-width: 1268px) {
    #medic-assistance
      > div.content.my-auto.col-md-12.col-lg-6
      > div
      > div
      > div
      > p {
      font-size: 1rem;
    }
  }
  .btn-more-info-white {
    span {
        color: white !important;font-weight:bold; border-color:white;font-size:0.8rem;
      }
  }
   .btn-more-info-white:hover{
    color: #eee;
    background-color: #3238C4;
    border-color: #3238C4;
    span {
      color: #1D1D1E !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/MedicalAssistance.vue